var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39871 20.9035C1.51826 20.9035 0.804507 21.6173 0.804505 22.4977C0.804505 23.3782 1.51826 24.092 2.39871 24.092L20.8449 24.092L20.8449 42.5381C20.8449 43.4186 21.5586 44.1323 22.4391 44.1323C23.3195 44.1323 24.0333 43.4186 24.0333 42.5381V24.092L42.4795 24.092C43.3599 24.0919 44.0737 23.3782 44.0737 22.4977C44.0737 21.6173 43.3599 20.9035 42.4795 20.9035L24.0333 20.9035L24.0333 2.45737C24.0333 1.57691 23.3195 0.863163 22.4391 0.863163C21.5586 0.863163 20.8449 1.57691 20.8449 2.45737L20.8449 20.9035L2.39871 20.9035Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f5dca0ecb66340ad872ab5fb6b8d7870.svg";
export { ForwardRef as ReactComponent };